var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-btn'),_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('da-form',{on:{"emitDaData":_vm.createDA}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }